import { useCallback } from 'react';
import { CANVAS_PAD, usePagePreviewScale } from '../shared/usePagePreviewScale';
import EmbassyBirthFormPreview, {
    EMBASSY_BIRTH_PAGE_HEIGHT,
    EMBASSY_BIRTH_PAGE_WIDTH,
} from './EmbassyBirthFormPreview';

/**
 * The one-page form inside the sticky preview rail, scaled to fit the card so
 * the whole sheet — slip included — is on screen at once. Zoomed in past the
 * card, it is dragged around instead.
 */
export default function EmbassyBirthPreviewFrame({ form, previewRef, zoom = 1 }) {
    const [scrollRef, scale] = usePagePreviewScale(
        EMBASSY_BIRTH_PAGE_WIDTH,
        EMBASSY_BIRTH_PAGE_HEIGHT,
        zoom,
        1,
    );

    const assignPreviewRef = useCallback(
        (node) => {
            if (typeof previewRef === 'function') {
                previewRef(node);
            } else if (previewRef) {
                previewRef.current = node;
            }
        },
        [previewRef],
    );

    return (
        <div className="relative flex min-h-0 w-full flex-1">
            <div
                ref={scrollRef}
                className="w-full min-h-0 flex-1 select-none overflow-auto rounded-lg bg-[#3d3d3d]"
                style={{ padding: CANVAS_PAD }}
            >
                {/* The scaled paper is laid out at full size, so the scroll box is
                    given the height the transform actually paints. */}
                <div
                    style={{
                        height: EMBASSY_BIRTH_PAGE_HEIGHT * scale,
                        width: EMBASSY_BIRTH_PAGE_WIDTH * scale,
                        margin: '0 auto',
                    }}
                >
                    <div
                        className="shadow-[0_8px_32px_rgba(0,0,0,0.35)]"
                        style={{
                            width: EMBASSY_BIRTH_PAGE_WIDTH,
                            transform: `scale(${scale})`,
                            transformOrigin: 'top left',
                        }}
                    >
                        <EmbassyBirthFormPreview ref={assignPreviewRef} form={form} />
                    </div>
                </div>
            </div>
        </div>
    );
}
